import {libraryDriveLinks as links} from './privateContent';
export function libraryDriveUrl(item){
 if(item?.source_type!=='book')return null;
 const url=item.drive_url||links[item.source_id]?.url;
 return typeof url==='string'&&/^https:\/\/drive\.google\.com\/file\/d\/[A-Za-z0-9_-]{20,}\/view$/.test(url)?url:null;
}
export const driveCopy={
 tr:["PDF’yi Google Drive’da aç","Yeni sekmede açılır; dosyanın mevcut Google Drive erişim izinleri geçerlidir."],
 en:["Open PDF in Google Drive","Opens in a new tab; the file’s existing Google Drive permissions apply."],
 de:["PDF in Google Drive öffnen","Öffnet in einem neuen Tab; die bestehenden Drive-Zugriffsrechte gelten."],
 ar:["افتح PDF في Google Drive","يفتح في علامة تبويب جديدة؛ تسري أذونات الوصول الحالية للملف."],
 fr:["Ouvrir le PDF dans Google Drive","S’ouvre dans un nouvel onglet ; les autorisations Drive existantes s’appliquent."],
 es:["Abrir PDF en Google Drive","Se abre en una pestaña nueva; se aplican los permisos existentes de Drive."],
 ru:["Открыть PDF в Google Drive","Откроется в новой вкладке; действуют текущие разрешения Drive."],
 zh:["在Google Drive中打开PDF","在新标签页中打开；文件原有的Drive访问权限保持有效。"]
};

driveCopy.fa = ["باز کردن PDF در Google Drive", "در برگه تازه باز می‌شود؛ مجوزهای موجود فایل در Google Drive معتبر می‌مانند."];
